
/*********************************************************************
 *
 * WARNING: This shader class is automatically generated, any manual
 * edits will be lost.
 *
 ********************************************************************/
import { ShaderBase, ShaderUniformsContainer, ShaderAttributesContainer } from '../shader';
import { Texture, CubeMapTexture } from '../../texture';
import { Context } from '../../context/Context';
import { mat3, mat4, vec2, vec3, vec4 } from "gl-matrix";
import { ShaderSourceParser } from '../shader-source-parser';

export type CsmMomentsResolveShaderUniforms = {
	uDepthMap: WebGLUniformLocation
};

export type CsmMomentsResolveShaderAttributes = {
	aVertexPosition: number,
	vTexCoord: number
};

export type CsmMomentsResolveShaderSettings = string[];

export class CsmMomentsResolveShader extends ShaderBase<CsmMomentsResolveShaderUniforms, CsmMomentsResolveShaderAttributes> {

    private static fragmentShaderSource = `
in vec2 vTexCoord;
out vec4 fragColor;

uniform sampler2D uDepthMap;

// Positive-warp constant. Must match csm_shadow.glsl and csm-moments-blend.
// 5.0 is the canonical fp32 EVSM value; higher amplified per-shadow-texel
// blur variance into visible quantization cells on glancing surfaces.
#define C_EVSM 5.0

void main(void) {
	float d = texture(uDepthMap, vTexCoord).r;
	float warped = exp(C_EVSM * d);
	fragColor = vec4(warped, warped * warped, 0.0, 0.0);
}
`;

    private static vertexShaderSource = `
// --- begin: fullscreen_quad.vert.glsl ---
layout(location = 0) in vec2 aVertexPosition;
out vec2 vTexCoord;

void main(void) {
	vTexCoord = aVertexPosition * 0.5 + 0.5;
	gl_Position = vec4(aVertexPosition, 0.0, 1.0);
}
// --- end: fullscreen_quad.vert.glsl ---
`;

    public override get version(): string {
        return '300 es';
    }

    public override get parser(): any {
        return new ShaderSourceParser();
    }

    protected override get warnAttributeMismatch(): boolean {
        return false;
    }

    public uniformsContainer: CsmMomentsResolveShaderUniformsContainer;
    public attributesContainer: CsmMomentsResolveShaderShaderAttributesContainer;

    constructor(ctx: Context, settings: CsmMomentsResolveShaderSettings) {
        super(ctx, CsmMomentsResolveShader.fragmentShaderSource, CsmMomentsResolveShader.vertexShaderSource, settings);
        this.uniformsContainer = new CsmMomentsResolveShaderUniformsContainer(ctx, this);
        this.attributesContainer = new CsmMomentsResolveShaderShaderAttributesContainer(ctx, this);
    }
}

class CsmMomentsResolveShaderUniformsContainer extends ShaderUniformsContainer {
    constructor(ctx: Context, private shader: CsmMomentsResolveShader) {
        super(ctx);
    }

    public setDepthMap(texture: Texture) : CsmMomentsResolveShaderUniformsContainer {
        this.setTextureValue('uDepthMap', this.shader.uniforms.uDepthMap, texture, 'sampler2D');
        return this;
    }

    protected getTextureUniforms() {
        return [
			{ name: 'uDepthMap', uniform: this.shader.uniforms.uDepthMap, dataType: 'sampler2D' }
        ];
    }
}

class CsmMomentsResolveShaderShaderAttributesContainer extends ShaderAttributesContainer {
    constructor(ctx: Context, private shader: CsmMomentsResolveShader) {
        super(ctx);
    }

    public setVertexPosition(settings: { length: number, offset: number, itemSize: number }) : CsmMomentsResolveShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.aVertexPosition, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }

    public setvTexCoord(settings: { length: number, offset: number, itemSize: number }) : CsmMomentsResolveShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.vTexCoord, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }
}